import { render, staticRenderFns } from "./commonModal.vue?vue&type=template&id=c22dc994&scoped=true"
import script from "./commonModal.vue?vue&type=script&lang=js"
export * from "./commonModal.vue?vue&type=script&lang=js"
import style0 from "./commonModal.vue?vue&type=style&index=0&id=c22dc994&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c22dc994",
  null
  
)

export default component.exports